import type { Goal, ProjectedWeight } from "shared/types";

export const GET_LOT_WEIGHT_PROJECTION = "GET_LOT_WEIGHT_PROJECTION";
export const LIST_LOT_GOALS = "LIST_LOT_GOALS";

export type LotActionsDispatchAction =
  | {
      type: typeof GET_LOT_WEIGHT_PROJECTION;
      payload: { projectedWeight: ProjectedWeight | null };
    }
  | {
      type: typeof LIST_LOT_GOALS;
      payload: { goals: Goal[] };
    };

export const getLotWeightProjection = (
  projectedWeight: ProjectedWeight | null
): LotActionsDispatchAction => {
  return {
    type: GET_LOT_WEIGHT_PROJECTION,
    payload: { projectedWeight },
  };
};

export const listLotGoals = (goals: Goal[]): LotActionsDispatchAction => {
  return {
    type: LIST_LOT_GOALS,
    payload: { goals },
  };
};
